var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validStatus)?_c('span',{staticClass:"d-block text-white text-center",style:(`padding: 5px; background-color: ${_vm.validStatus.color};`)},[_vm._v(_vm._s(_vm.validStatus.label.startsWith("Traité") ? "Traité" : _vm.validStatus.label))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }